<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.OperateType')"
    width="370px"
    append-to-body
    :close-on-click-modal="false"
    class="app-main-inner"
    :before-close="()=>{$emit('cancel');innerVisible=false}"
  >
    <div class="app-main-row">
      <el-radio v-model="operateType" no="OneMasterAndManyPoints" :label="0">{{ $t('Message.OneMasterAndManyPoints') }}</el-radio>
      <el-radio v-model="operateType" no="DirectBusiness" :label="1">{{ $t('Message.DirectBusiness') }}</el-radio>
      <el-radio v-model="operateType" no="OneMasterAndOneMinute" :label="2">{{ $t('Message.OneMasterAndOneMinute') }}</el-radio>
    </div>
    <span slot="footer">
      <el-button no="invoice_confirm" type="primary" @click="successHandler">{{ $t('Invoice.invoice_confirm') }}</el-button>
      <el-button no="Cancel" @click="$emit('cancel');innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AIROPTypeDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      operateType: 0
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    successHandler() {
      this.$emit('successHandle', this.operateType)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
